import React from 'react';
import ProgressReportView from '../components/ProgressReportView';

export default function ParentCard() {
  return <ProgressReportView heading="Parent Card" subheading="A report designed to review with a parent or guardian" />;
}
